import React, { Component } from 'react';
import Card from '../../../Utils/Cards/Card';
import Header from 'Utils/Grid/Header';
import Grid from '../../../Utils/Grid';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { standardActions } from '../../../Utils/Grid/StandardActions';
import { EN_CURSO, FINALIZADO } from '../../../../../utility/constants';
import moment from 'moment';

class EnCurso extends Component {
    componentDidMount() {
        const { listar, page } = this.props;
        listar(page);
    }
    
    render() {
        const { listar: onPageChange, onSortChange, eliminar } = this.props;
        const { data, loader, page } = this.props
        return (
            <React.Fragment>
                <Header to="despacho/crear" textBtn="CREAR DESPACHO" {...this.props}/>
                <Grid
                    hover
                    striped
                    data={data}
                    loading={loader}
                    onPageChange={onPageChange}
                    onSortChange={onSortChange}
                    page={page}
                >
                    <TableHeaderColumn
                        dataField="id"
                        dataAlign="center"
                        dataSort
                        width="10%"
                        dataFormat={standardActions({ ver: 'despacho', editar: 'despacho', eliminar })}
                    />
                    <TableHeaderColumn
                        isKey
                        dataField="id"
                        width="5%"
                        dataSort
                    >
                        ID
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="producto"
                        dataSort
                        dataFormat={cell => cell.nombre}
                    >
                        PRODUCTO
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="cliente"
                        dataSort
                        dataFormat={cell => cell.nombre}
                    >
                        CLIENTE
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="fecha"
                        dataSort
                        dataFormat={cell => moment(cell).format("DD/MM/YYYY")}
                    >
                        FECHA
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="piloto"
                        dataSort
                        dataFormat={cell => cell.nombre}
                    >
                        PILOTO
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="peso_tara_equipo"
                        dataSort
                        dataFormat={cell => `<div>${cell} kg</div>`}
                    >
                        PESO DE ENTRADA
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="peso_bruto_despacho"
                        dataSort
                        dataFormat={cell => cell === null ? '<div>0 kg</div>' : `<div>${cell} kg</div>`}
                    >
                        PESO DE SALIDA
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="peso_neto"
                        dataSort
                        dataFormat={cell => `<div>${cell} kg</div>`}
                    >
                        PESO NETO
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="estado"
                        dataFormat={cell => {
                            switch(cell) {
                                case EN_CURSO:
                                    return '<div style="color: #b73333;">En curso</div>';
                                case FINALIZADO:
                                    return '<div>Finalizado</div>';
                            }
                        }}
                    >
                        ESTADO
                    </TableHeaderColumn>
                </Grid>
            </React.Fragment>
        )
    }
}

export default EnCurso